import { render, staticRenderFns } from "./consultingreview.vue?vue&type=template&id=fdbf5c50&"
import script from "./consultingreview.vue?vue&type=script&lang=js&"
export * from "./consultingreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports